import type { ComponentProps } from "react";

import { LightbulbIcon } from "@/shared/ui/icons";
import { tw } from "@/shared/utils";

const Root = ({ className, ...props }: ComponentProps<"section">) => (
  <section
    className={tw(
      "flex grow flex-col items-center justify-center gap-2 rounded-2xl p-4 text-center md:p-6",

      className,
    )}
    {...props}
  />
);

const Icon = ({ className, children, ...props }: ComponentProps<"div">) => (
  <div
    className={tw("size-14 text-secondary-200 sm:size-16", className)}
    {...props}
  >
    {children ?? <LightbulbIcon />}
  </div>
);

const Title = ({ className, children, ...props }: ComponentProps<"h3">) => (
  <h3
    className={tw("text-xl font-semibold text-neutral-500", className)}
    {...props}
  >
    {children}
  </h3>
);

const Description = ({ className, ...props }: ComponentProps<"p">) => (
  <p
    className={tw("max-w-xl text-xl font-medium text-neutral-500", className)}
    {...props}
  />
);

export const EmptyState = { Root, Title, Description, Icon };
